<template>
  <div :class="'campaign-item-wrap' + ` ${this.statusClass}`">
    <div class="campaign-item" @click="$emit('view')">
      <span class="campaign-author">{{ author }}</span>
      <h3 class="campaign-name" :title="name">
        {{ name }}
      </h3>
      <div class="campaign-range">{{ start }} 부터 {{ end }} 까지</div>

      <div class="campaign-footer">
        <span :class="`status ${statusClass}`">{{ status }}</span>
        <div class="campaign-tool" v-if="isAdmin">
          <span @click.stop="$emit('modify')">
            <i class="fas fa-pen-alt" />
          </span>
          <span @click.stop="$emit('delete')">
            <i class="fas fa-trash-alt"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CampaignItem",
  props: {
    start: String,
    end: String,
    status: String,
    author: String,
    name: String,
    isAdmin: Boolean,
  },
  computed: {
    statusClass() {
      return this.status === "예약"
        ? "reserve"
        : this.status === "종료"
        ? "end"
        : "ing";
    },
  },
};
</script>

<style lang="scss">
@import "~styles/color";

.campaign-item-wrap {
  width: 25%;
  display: inline-block;
  padding: 16px;

  &.end .campaign-item {
    & * {
      color: #8b8b8b;
    }
  }
}

@media (max-width: 1024px) {
  .campaign-item-wrap {
    width: 33.3%;
    padding: 12px;
  }
}

@media (max-width: 768px) {
  .campaign-item-wrap {
    width: 50%;
    padding: 8px;
  }
}

.campaign-item {
  cursor: pointer;
  font-size: 14px;
  padding: 20px;
  box-shadow: 0 0px 10px 0px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
  transition: all 0.3s;
  background-color: white;
  user-select: none;

  &:hover {
    box-shadow: none;
    background-color: #f1f1f1;
  }
}

.campaign-author {
  font-size: 12px;
  color: #333;
}

.campaign-name {
  margin: 10px 0;
  font-size: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
}

.campaign-range {
  font-size: 13px;
  color: #333;
}

.campaign-footer {
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;

  .status {
    font-size: 12px;
    padding: 3px 7px;
    border-radius: 5px;
    cursor: default;

    &.reserve {
      @extend %info_setting;
    }

    &.ing {
      @extend %success_setting;
    }
  }

  .campaign-tool {
    span {
      cursor: pointer;
    }

    span + span {
      margin-left: 16px;
    }
  }
}
</style>
